// extracted by mini-css-extract-plugin
export default {"blender_bottle_item":"vE","blender_bottle_img":"wE","blender_bottle_info":"xE","blender_bottle_title":"yE","blender_bottle_bold":"zE","blender_bottle_usual":"AE","blender_bottle_item_mob":"BE","addbutton":"CE","blender_bottle_title_mob":"EE","blender_bottle_bold_mob":"FE","blender_bottle_usual_mob":"GE","bolder":"HE","bottom_margin_4":"IE","bottom_margin_16":"JE"};
    if(module.hot) {
      // 1715091679211
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  